const dateTimePicker = {
  update: (field, appData, extraData) => {
    const {
      date: { value: dateValue, fieldName: dateFieldName },
      time: { value: timeValue, fieldName: timeFieldName }
    } = extraData;
    const isRequired = !field.params.includes("TDFieldOptionIsOptional");
    const isValid = !!appData.values[field.name];

    const isLocalFieldValid = {
      [dateFieldName]: !!dateValue,
      [timeFieldName]: !!timeValue
    };
    const getErrorMessage = localFieldName =>
      !isLocalFieldValid[localFieldName]
        ? `${localFieldName} field is missing`
        : null;

    const errorMessage = {
      [dateFieldName]: getErrorMessage(dateFieldName),
      [timeFieldName]: getErrorMessage(timeFieldName)
    };

    const fieldObject = {
      fieldName: field.name,
      isValid,
      isRequired,
      title: field.title,
      errorMessage,
      isLocalFieldValid
    };
    const fieldsArray = appData.screenValidation.fields;
    const index = fieldsArray.findIndex(
      fieldItem => fieldItem.fieldName === field.name
    );
    if (index > -1) {
      fieldsArray[index] = fieldObject;
    } else {
      fieldsArray.push(fieldObject);
    }

    return fieldObject;
  }
};

export default dateTimePicker;
